import { ca } from '@cian/analytics';

export function trackClick() {
  ca('event', {
    action: 'print_open_main_block',
    category: 'card',
    label: '',
    name: 'oldevent',
  });
}
